import Color from 'color';

const NUM_OF_INDEXES_PER_ATTR = 10;
const MAX_INDEX_VALUE = 100;

export function getLimitsLineWeight(min, max, id) {
  return ['case',
    ['==', ['feature-state', `layer_${id}_weight`], null],
    0,
    ['all',
      ['>=', ['feature-state', `layer_${id}_weight`], min],
      ['<=', ['feature-state', `layer_${id}_weight`], max],
    ], 0.6, 0
  ];
}

export function getLayerColors(
  baseColorSelected,
  minSelected = 0,
  maxSelected = 100
) {
  const baseColor = Color(baseColorSelected[0]).darken(0.7);
  let currentColor;
  let weightRest = MAX_INDEX_VALUE;
  const rest = MAX_INDEX_VALUE / NUM_OF_INDEXES_PER_ATTR;
  const weightsList = [];
  while (weightRest > 0) {
    weightsList.push(weightRest);
    weightRest -= rest;
  }
  weightsList.reverse();
  return weightsList.map((weight, key) => {
    let disabledColor;
    if ((baseColorSelected.length > 1)) {
      currentColor = baseColorSelected[key] ? Color(baseColorSelected[key]) : baseColorSelected[baseColorSelected.length - 1];
    } else {
      currentColor = key === 0 ? baseColor : currentColor.lighten(0.2);
    }
    if (weight < minSelected || weight > maxSelected) {
      disabledColor = '#403e3b';
    }
    return {
      color: disabledColor || currentColor.hex(),
      weight
    };
  }).sort((numA, numB) => numA.weight - numB.weight);
}

export function getColorsList(baseLayerColor, indexLimits) {
  const colorsList = [];
  const weightListColors = getLayerColors(baseLayerColor, indexLimits.min, indexLimits.max);
  weightListColors.forEach(weightsList => {
    if (colorsList.length === 0) {
      colorsList.push(0, weightsList.color);
    }
    colorsList.push(weightsList.weight, weightsList.color);
  });
  colorsList.push(3000, '#ff0000');
  return colorsList;
}

export function getSimplePaintMapDataForLayer(color, indexLimits, id) {
  const colorsList = getColorsList(color, indexLimits);
  return ['case',
    ['!=', ['feature-state', `layer_${id}_weight`], null],
    [
      'interpolate',
      ['linear'],
      ['feature-state', `layer_${id}_weight`],
      ...colorsList
    ],
    '#403e3b'
  ];
}

export function getTagFilters(tags) {
  const filterOfTags = ['any'];
  Object.keys(tags).forEach(tagLevel => {
    tags[tagLevel].forEach(tagItem => {
      filterOfTags.push(['has', `tag_${tagLevel}_${tagItem.split('.').join('_')}`]);
    });
  });
  return filterOfTags;
}
